module.exports = __webpack_public_path__ + "img/unisul-branco.96de4a90.svg";